import { FC, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import PersonalStats from "./components/pages/personal-stats/PersonalStats";
import ProtectedRoutes from "./utils/ProtectedRoutes";
import AdminRoutes from "./utils/AdminRoutes";
import OperatorEdit from "./components/pages/form-edit/OperatorEdit";
import AdminTickets from "./components/pages/admin-tickets/AdminTickets";
import AdminDialog from "./components/pages/admin-dialog/AdminDialog";
import AdminUsers from "./components/pages/admin-tickets/AdminUsers";
import UserEdit from "./components/pages/form-edit/UserEdit";
import TicketStats from "./components/pages/form-edit/requests-stats/RequestsStats";
import IdentificationStatus from "./components/pages/operator/Identification-request-status";
import RequestStatus from "./components/pages/operator/Request-status";
import CreateDeveloperTicket from "./components/pages/operator/Developer-tickets";
import DeveloperTickets from "./components/pages/operator/Developer";
import DevRoutes from "./utils/DevRoutes";
import GscOperatorRequestStatusPage from "./components/pages/gsc-operators/gsc-operators-search";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OperatorRoutes from "./utils/OperatorRoutes";
import GSCRoute from "./utils/GscRoutes";
import NotFoundPage from "./components/pages/not-found/NotFoundPage";

interface IAppProps {}

const Admin = lazy(() => import("./components/pages/admin/Admin"));
const Operator = lazy(() => import("./components/pages/operator/Operator"));
const Auth = lazy(() => import("./components/pages/auth/Auth"));

const App: FC<IAppProps> = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Auth />} />

        <Route element={<ProtectedRoutes />}>
          <Route element={<DevRoutes />}>
            <Route path="/developer" element={<DeveloperTickets />} />
          </Route>

          <Route element={<AdminRoutes />}>
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/tickets" element={<AdminTickets />} />
            <Route path="/admin/tickets/dialog/:id" element={<AdminDialog />} />
            <Route path="/admin/stats/:id" element={<PersonalStats />} />
            <Route path="/admin/edit/:id" element={<OperatorEdit />} />
            <Route path="/admin/user-edit/:id" element={<UserEdit />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/request-stats" element={<TicketStats />} />
          </Route>

          <Route element={<GSCRoute />}>
            <Route
              path="/check-status"
              element={<GscOperatorRequestStatusPage />}
            />
          </Route>

          <Route element={<OperatorRoutes />}>
            <Route path="/operator" element={<Operator />} />

            <Route
              path="/operator/identification-status"
              element={<IdentificationStatus />}
            />

            <Route
              path="/operator/request-status"
              element={<RequestStatus />}
            />

            <Route
              path="/operator/developer-tickets"
              element={<CreateDeveloperTicket />}
            />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default App;